<template>
        <div class="account-page">
    <div class="main-wrapper">
      <layout-header></layout-header>
  <div class="main_home_content">
    <div class="container">
      <div class="row">
        <div class="col-md-10 offset-md-1 pt-1 pb-5" style="margin-top: 20px;">
          <div class="home-content">
            <div class="row align-items-center justify-content-center">
              <div class="col-md-7 col-lg-6">
                <h2 class="right_heading" style="margin-top: 30px;">
                  Multiple Hospital Schedules for Healthcare Practitioner
                </h2>
                <h4 class="right_headline">
                  Scheduling Simplified Across Multiple Hospitals
                </h4>
                <h5 class="right_content">
                  Your Practice, Your Schedule – Managed Effortlessly with
                  {{main_data}}
                </h5>
                <p class="right_content">
                  Juggling schedules across multiple hospitals can be a daunting
                  task. {{main_data}} Multiple Hospital Schedules
                  feature is designed to alleviate this complexity, offering
                  healthcare practitioners an intuitive and centralized platform
                  to manage all their hospital schedules. Seamlessly view,
                  adjust, and coordinate your schedules across various hospitals
                  – all in one place.
                </p>
                <div style="margin-top: 50px;"></div>
              </div>
              <div class="col-md-12 col-lg-5">
                <img style="height: 300px;"
                  src="@/assets/img/multipledoctor.jpeg"
                  class="img-fluid"
                  alt="Doccure Login"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="row mt-1">
        <div class="col-md-10 offset-md-1">
          
          <h4 class="right_content pb-3" align="center">
            <h2 style="font-weight: bold;">Unified Schedule View</h2>
          </h4>
          <!-- <p><strong>Healthcare Practitioner Schedules:</strong></p> -->
          <b-card-group deck>
            <b-card
              border-variant="dark"
              header="All Your Schedules, One Dashboard"
              header-bg-variant="dark"
              header-text-variant="white"
              style="font-size: 20px;"
            >
              <b-card-text style="font-size: 17px;"
                >View all your schedules across different hospitals in one
                unified dashboard. No more switching between platforms or manual
                tracking – everything you need is right here. Real-Time
                Availability Management</b-card-text
              >
            </b-card>
            <b-card
              border-variant="dark"
              header="Keep Your Availability Updated"
              header-bg-variant="dark"
              header-text-variant="white"
            >
              <b-card-text
                >Easily mark your availability and block off time for breaks or
                other commitments. Real-time updates ensure that your schedule
                is always accurate and up-to-date across all hospitals.
              </b-card-text>
            </b-card>
            <b-card
              border-variant="dark"
              header="Seamless Integration with Hospital Systems"
              header-bg-variant="dark"
              header-text-variant="white"
            >
              <b-card-text
                >Our platform seamlessly integrates with existing hospital
                scheduling systems. Any changes you make are automatically
                reflected across all connected systems, ensuring
                consistency.</b-card-text
              >
            </b-card>
          </b-card-group>
        </div>
      </div>
    </div>
    <div style="margin-top: 50px;">
        <h4 class="right_content pb-5" align="center">
            <h2 style="font-weight: bold; "> Why Choose Multiple Hospital Schedules? </h2>
          </h4>
    </div>
    <div class="mt-6">
      <div>
        <div class="row mt-1">
          <div class="col-md-10 offset-md-1">
            <!-- <p><strong>Healthcare Practitioner Schedules:</strong></p> -->
            <b-card-group deck>
              <b-card
                border-variant="dark"
                header="Efficiency"
                header-bg-variant="dark"
                header-text-variant="white"
                style="font-size: 20px;"
              >
                <b-card-text style="font-size: 17px;"
                  > Manage all your schedules in one place, saving time and reducing errors.</b-card-text
                >
              </b-card>
              <b-card
                border-variant="dark"
                header="Flexibility"
                header-bg-variant="dark"
                header-text-variant="white"
              >
                <b-card-text
                  >Adjust and coordinate your schedules across various hospitals effortlessly.
                </b-card-text>
              </b-card>
              <b-card
                border-variant="dark"
                header="Integration"
                header-bg-variant="dark"
                header-text-variant="white"
              >
                <b-card-text>
                    Seamless connection with existing hospital systems for cohesive workflow.</b-card-text
                >
              </b-card>
            </b-card-group>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-5"
      style="display: flex; justify-content: center; align-items: center;"
    >
      <div style="width: 500px; text-align: center;">
        <b-card bg-variant="info" text-variant="white" title="" style="border:1px solid black">
          <b-card-text style="text-align: center;">
            "Embrace the future of healthcare scheduling with {{main_data}} Multiple Hospital Schedules. Register today and experience scheduling like never before!"
          </b-card-text>
          <b-button href="#" variant="dark" style="text-align: center;">
            Register Now
          </b-button>
        </b-card>
      </div>
    </div>
  </div>
  <layout-footer></layout-footer>
    </div>
    </div>
</template>

<script>
import config from "../../services/CommonApi";
import axios from "axios";
export default {
  data() {
    return {
      main_data: "",
      config: config,
    };
  },
  mounted() {
    this.get_practitioner_profile();
  },
  methods: {

    async get_practitioner_profile() {
      var domain = window.location.hostname;

      const formdata = {
        domain: window.location.hostname,
      };
      await axios
        .get(
          "https://develop-physio.kneexpert.in/api/method/sahaj.domain.get_hospital?domain=" +
          window.location.hostname
        )
        .then((res) => {
          this.showspinner = false;
          if (res.data.status_code == 200) {
            this.main_data = res.data.data[0].brand_name
          }
          if (res.data.status_code == 404) {
            if (window.location.hostname == "physio.sahajhelp.com") {
            } else if (window.location.hostname == "physio.kneexpert.in") {
            } else if (window.location.hostname == "localhost") {
            }
            else if (window.location.hostname.startsWith("192.168")) {
            } else if (window.location.hostname == "iitb.smartyhealthcare.in") {
            } else {
              window.location.href = String("https://physio.kneexpert.in");
            }
          }
          this.$swal.close();
        });
    },

  },
}
</script>

<style>
.right_heading {
  font-size: 40px;
  font-weight: bold;
  font-family: sans-serif;
}

.right_content {
  font-size: 18px;
  margin-top: 20px;
  font-family: sans-serif;
}
.right_headline {
  margin-top: 20px;
}
.btn {
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/kneexpert/MultipleHospital.vue